import { Injectable } from '@angular/core'
import {
	Resolve,
	ActivatedRouteSnapshot,
	RouterStateSnapshot
} from '@angular/router'
import { Observable } from 'rxjs'
import { DemandService } from '../../../services/demand.service'
import { Demand } from '../../../models/Demand'

@Injectable({ providedIn: 'root' })
export class DemandsHistoryResolver implements Resolve<Observable<Demand>> {
	constructor(
		private demandService: DemandService
	) {}

	public async resolve(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Promise<any> {

	}
}
